import { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ALLOWED_USER } from "../../constants";
import { setLoginDetails } from "../../store/auth";

export const useAdminLoginData = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isEmail, setIsEmail] = useState("");
  const [isPassword, setIsPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = useCallback(() => {
    setShowPassword((prev) => !prev);
  }, []);

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      const validUser = ALLOWED_USER.find(
        (user) => user.email === isEmail && user.password === isPassword
      );
      if (!validUser) {
        toast.error("Invalid email or password!");
        return;
      }
      const userLoginDetails = {
        type: validUser.type,
        email: validUser.email,
        isLoggedIn: true,
      };
      localStorage.setItem(
        "adminLoginDetails",
        JSON.stringify(userLoginDetails)
      );
      dispatch(setLoginDetails(userLoginDetails));
      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false);
        toast.success("Login successful!");
        navigate("/admin-dashboard");
      }, 2000);
    },
    [isEmail, isPassword, dispatch, navigate]
  );

  useEffect(() => {
    const adminLoginDetails = localStorage.getItem("adminLoginDetails");
    if (adminLoginDetails) {
      const details = JSON.parse(adminLoginDetails);
      if (details.isLoggedIn) {
        toast.info(`You are already logged in as ${details.type}.`);
        navigate("/admin-dashboard");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    handleSubmit,
    isEmail,
    setIsEmail,
    isPassword,
    setIsPassword,
    showPassword,
    handleTogglePassword,
    isLoading,
  };
};
